import React from "react";
import { Collapse, Input } from "antd";
import "./app_collapse.css";
import UtilBloc from "../../../bloc/util_bloc";
import { ReactComponent as ArrowDownIcon } from "../../../ArrowDownIcon.svg";
import { ReactComponent as ChevronRightIcon } from "../../../ChevronRight2.svg";

const { Panel } = Collapse;

class AppCollapse extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            lastValue: 0,
        };
    }
    propHeader = () => {
        return this.props.header;
    }

    propBackgroundColor = () => {
        return this.props.backgroundColor;
    }

    propchildren = () => {
        return this.props.children;
    }

    propExpandIcon = () =>{
        return this.props.expandIcon || null;
    }

    render() {
        return (
            <div className="collapse_container mt-3 d-flex align-items-center" style={{ border: this.props.borderEnable === false ? '0px' : '1px solid rgba(224, 224, 224, 1)' }}>
                <Collapse
                    className="p-1 d-flex align-items-center justify-items-center w-100"
                    bordered={false}
                    expandIconPosition={"start"}
                    style={{
                        backgroundColor: this.propBackgroundColor() || 'white',
                        display: "flex",
                    }}
                    defaultActiveKey={['0']}
                    expandIcon={(isActive) =>
                        isActive.isActive ? <ArrowDownIcon className="collapse_icon" />
                            : <ChevronRightIcon className="collapse_icon" />
                    }

                >
                    <Panel
                        key={this.props?.expand || this.propHeader()}
                        header={this.propHeader() || ""}
                        className="collapse_title w-100"
                        extra={this.props.extra}
                    >
                        <div className="collapse_desc ml-2 ">
                            {this.propchildren()}
                        </div>
                    </Panel>
                </Collapse>
            </div>
        );
    }
}

export default AppCollapse;
